if (!customElements.get('cork-cutting-notice')) {
  customElements.define('cork-cutting-notice', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('quick-order-list, product-info');
      if (!this.root) return;
      this.variantIds = new Set(this.dataset.variantIds.split(',').filter(Boolean));
      this.update = this.update.bind(this);
      this.root.addEventListener('input', this.update);
      this.root.addEventListener('change', this.update);
      this.unsubscribers = [];
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.quantityUpdate, this.update));
        this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.variantChange, this.update));
      }
      this.update();
    }

    disconnectedCallback() {
      this.root?.removeEventListener('input', this.update);
      this.root?.removeEventListener('change', this.update);
      this.unsubscribers?.forEach(unsubscribe => unsubscribe());
    }

    update() {
      let variantId = this.root.querySelector('product-form input[name="id"]')?.value;
      let quantityInput = this.root.querySelector('input[name="quantity"]');
      if (this.root.matches('quick-order-list')) {
        quantityInput = Array.from(this.root.querySelectorAll('input[data-quantity-variant-id]')).find(input =>
          this.variantIds.has(input.dataset.quantityVariantId) && Number(input.value) >= 2 && Number(input.value) <= 5
        );
        variantId = quantityInput?.dataset.quantityVariantId;
      }
      const quantity = Number(quantityInput?.value || 1);
      const shouldShow = this.variantIds.has(variantId) && Number.isInteger(quantity) && quantity >= 2 && quantity <= 5;
      if (shouldShow) {
        const summary = this.querySelector('[data-summary]');
        summary.textContent = summary.dataset.template.replaceAll('__quantity__', String(quantity));
      }
      this.hidden = !shouldShow;
    }
  });
}
